import React from 'react';
import { useSnackbar, VariantType, WithSnackbarProps } from 'notistack';
import { Button } from '@material-ui/core';

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

const InnerSnackbarUtilsSetup: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsSetup = () => {
  return (
    <InnerSnackbarUtilsSetup setUseSnackbarRef={setUseSnackbarRef} />
  );
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  success(msg: string) {
    this.toast(msg, 'success');
  },
  warning(msg: string) {
    this.toast(msg, 'warning');
  },
  info(msg: string) {
    this.toast(msg, 'info');
  },
  error(msg: string) {
    this.toast(msg, 'error');
  },
  toast(msg: string, variant: VariantType = 'default') {
    useSnackbarRef.enqueueSnackbar(msg, {
      variant,
      action: key => (
        <Button
          style={{ color: 'white' }}
          size="small"
          onClick={() => useSnackbarRef.closeSnackbar(key)}
        >
          x
        </Button>
      ),
    });
  },
};